export default {"src":"/_next/static/media/location-icon.c6221a08.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};